import type { ContractResponse, PropertyFileResponse, SupplierInvoiceResponse } from '@/shared/api';
import { FilePreviewModal } from './FilePreviewModal';
import { PropertyFileEditModal } from './PropertyFileEditModal';
import { ContractEditModal } from './ContractEditModal';
import { SupplierInvoiceEditModal } from './SupplierInvoiceEditModal';

interface Props {
  propertyId: string;
  previewFile: PropertyFileResponse | null;
  editFile: PropertyFileResponse | null;
  editContract: ContractResponse | null;
  editInvoice: SupplierInvoiceResponse | null;
  onClosePreview: () => void;
  onCloseEditFile: () => void;
  onCloseEditContract: () => void;
  onCloseEditInvoice: () => void;
  onDownload: (f: PropertyFileResponse) => void;
}

/** Bündelt Preview- + Edit-Modals für Datei/Vertrag/Rechnung. */
export function AkteEditModals({
  propertyId,
  previewFile,
  editFile,
  editContract,
  editInvoice,
  onClosePreview,
  onCloseEditFile,
  onCloseEditContract,
  onCloseEditInvoice,
  onDownload,
}: Props) {
  return (
    <>
      <FilePreviewModal
        open={previewFile !== null}
        onOpenChange={(v) => !v && onClosePreview()}
        propertyId={propertyId}
        file={previewFile}
        onDownload={onDownload}
      />
      <PropertyFileEditModal
        open={editFile !== null}
        onOpenChange={(v) => !v && onCloseEditFile()}
        propertyId={propertyId}
        file={editFile}
      />
      <ContractEditModal
        open={editContract !== null}
        onOpenChange={(v) => !v && onCloseEditContract()}
        propertyId={propertyId}
        contract={editContract}
      />
      <SupplierInvoiceEditModal
        open={editInvoice !== null}
        onOpenChange={(v) => !v && onCloseEditInvoice()}
        propertyId={propertyId}
        invoice={editInvoice}
      />
    </>
  );
}
